module.exports = __webpack_public_path__ + "pic/60.b53dd3f7.png";